export default __webpack_public_path__ + "static/media/96.14a73278.png";